export const YEAR = "year";
export const AS_ON = "asOn";
export const TURN_OVER = "turnOver";
export const EBITDA = "ebitda";
export const EBITDA_MARGIN = "ebitdaMargin";
export const PAT = "pat";
export const PAT_MARGIN = "patMargin";
export const GROSS_BLOCK = "grossBlock";
export const DE = "de";
export const ROCE = "roce";
export const CURRENT_RATIO = "currentRatio";
export const TOTAL_DEBT = "totalDebt";
export const RONW = "ronw";

export const OSTWAL = "Ostwal Phoschem (India) Limited (OPIL)";
export const MADHYA = "Madhya Bharat Agro Products Limited (MBAPL)";
export const KRISHNA = "Krishana Phoschem Limited (KPL)";
export const SHRI = "Shri Ganpati Fertilizers Limited (SGFL)";
export const SEASONS = "Seasons International Private Limited (SIPL)";
export const NIRMALA = "Nirmala Real Infrastructure Private Limited (NRIPL)";
